/* eslint-disable eag/match-named-export */
import {all, fork} from 'typed-redux-saga';

import {userManagementSaga} from '../userManagement/saga';

export function* generalSettingsSaga(): Generator {
  yield* all([fork(userManagementSaga)]);
}
